import { ResourcePool } from "./castle";

export interface PveGarrisonStack {
  unitId: string;
  unitName: string;
  unitClass: number;
  count: number;
}

export interface PveCampEntry {
  id: string;
  name: string;
  description: string;
  tier: number;
  garrison: PveGarrisonStack[];
  loot: ResourcePool;
  heroXp: number;
  cooldownSeconds: number;
  nextAttackAt: string | null;
  onCooldown: boolean;
}

export const TierLabel: Record<number, { name: string; icon: string; color: string }> = {
  1: { name: "Easy", icon: "🟢", color: "text-green-300" },
  2: { name: "Medium", icon: "🟡", color: "text-yellow-300" },
  3: { name: "Hard", icon: "🟠", color: "text-orange-300" },
  4: { name: "Boss", icon: "🔴", color: "text-red-300" },
  5: { name: "Tier 5", icon: "💀", color: "text-purple-300" },
  6: { name: "Tier 6", icon: "👹", color: "text-purple-400" },
  7: { name: "Tier 7", icon: "🐲", color: "text-pink-300" },
};
